import { AxiosInstance } from 'axios'
import { Note } from '@dc-shared-web/hooks/api/comparison/types'

interface UpdateChangeNoteParams {
  content: string
  updated_by: string
}

export const updateChangeNote = async (
  apiClient: AxiosInstance,
  changeUuid: string,
  noteUuid: string,
  params: UpdateChangeNoteParams
): Promise<Note> => {
  const response = await apiClient.put(
    `/v1/notes/${changeUuid}/${noteUuid}`,
    params
  )
  return response.data
}
